<input
    #fileInput
    type="file"
    class="modal-profile-photo__file-input"
    [accept]="acceptedTypes"
    (change)="onFileSelected($event)"
/>

@switch (view()) {
    @case ('EDIT') {
        <eb-h2 class="modal-profile-photo__title">{{ 'profile.photo.edit_title' | transloco }}</eb-h2>

        <div class="modal-profile-photo__editor">
            <div class="modal-profile-photo__cropper-wrap">
                <image-cropper
                    #cropper
                    class="modal-profile-photo__cropper"
                    [allowMoveImage]="false"
                    [aspectRatio]="1 / 1"
                    [autoCrop]="false"
                    [imageFile]="editFile()"
                    [imageURL]="editUrl() ?? undefined"
                    [maintainAspectRatio]="true"
                    [roundCropper]="true"
                    [transform]="transform()"
                    (transformChange)="onTransformChange($event)"
                    format="png"
                />
            </div>

            <div class="modal-profile-photo__tools">
                <div class="modal-profile-photo__tool-buttons">
                    <button
                        type="button"
                        class="modal-profile-photo__tool-button"
                        [attr.aria-label]="'common.rotate_left' | transloco"
                        (click)="rotate(-1)"
                    >
                        <eb-icon
                            class="modal-profile-photo__icon-ccw"
                            icon="ui/action/symbols/reset"
                            width="20"
                        />
                    </button>
                    <button
                        type="button"
                        class="modal-profile-photo__tool-button"
                        [attr.aria-label]="'common.rotate_right' | transloco"
                        (click)="rotate(1)"
                    >
                        <eb-icon
                            class="modal-profile-photo__icon-cw"
                            icon="ui/action/symbols/reset"
                            width="20"
                        />
                    </button>
                    <button
                        type="button"
                        class="modal-profile-photo__tool-button"
                        [attr.aria-label]="'common.flip' | transloco"
                        (click)="flip()"
                    >
                        <eb-icon
                            icon="ui/action/symbols/mirror"
                            width="20"
                        />
                    </button>
                </div>

                <eb-label
                    class="modal-profile-photo__tool-label"
                    color="flat-secondary"
                    size="sm"
                    textTransform="uppercase"
                    weight="black"
                >
                    {{ 'profile.photo.zoom' | transloco }}
                </eb-label>
                <input
                    type="range"
                    class="modal-profile-photo__slider"
                    [attr.aria-label]="'profile.photo.zoom' | transloco"
                    [max]="maxZoom"
                    [min]="minZoom"
                    [step]="zoomStep"
                    [value]="transform().scale ?? minZoom"
                    (input)="onZoomChange(+$any($event.target).value)"
                />

                <eb-label
                    class="modal-profile-photo__tool-label"
                    color="flat-secondary"
                    size="sm"
                    textTransform="uppercase"
                    weight="black"
                >
                    {{ 'profile.photo.rotation' | transloco }}
                </eb-label>
                <input
                    type="range"
                    class="modal-profile-photo__slider"
                    [attr.aria-label]="'profile.photo.rotation' | transloco"
                    [max]="maxRotation"
                    [min]="minRotation"
                    [step]="1"
                    [value]="transform().rotate ?? minRotation"
                    (input)="onRotationChange(+$any($event.target).value)"
                />
            </div>
        </div>

        <div class="modal-profile-photo__footer">
            <eb-button-with-icon
                [label]="'common.cancel'"
                [size]="'small'"
                (buttonClick)="cancelEdit()"
                icon="ui/action/symbols/cross"
                iconWidth="20"
            >
                <eb-label
                    class="d-flex align-items-center p-1"
                    size="lg"
                >
                    {{ 'common.cancel' | transloco }}
                </eb-label>
            </eb-button-with-icon>
            <button
                eb-button
                [isV2]="true"
                [size]="'small'"
                [isLoading]="saving()"
                [disabled]="saving()"
                (click)="save()"
                color="primary-v2"
            >
                {{ 'profile.photo.save' | transloco }}
            </button>
        </div>
    }

    @default {
        <eb-h2 class="modal-profile-photo__title">{{ 'profile.photo.title' | transloco }}</eb-h2>

        <div class="modal-profile-photo__preview">
            @if (previewUrl(); as url) {
                <img
                    alt=""
                    class="modal-profile-photo__preview-image"
                    [src]="url"
                />
            } @else {
                <span class="modal-profile-photo__preview-initials">{{ [firstName, lastName] | nameInitials }}</span>
            }
        </div>

        <div class="modal-profile-photo__actions">
            <eb-button-with-icon
                [disabled]="!hasPhoto()"
                [hideIcon]="false"
                [label]="'profile.photo.modify'"
                (buttonClick)="goEdit()"
                icon="ui/action/symbols/pen"
                iconWidth="20"
            >
                <eb-label size="lg">{{ 'profile.photo.modify' | transloco }}</eb-label>
            </eb-button-with-icon>

            <eb-button-with-icon
                [label]="'profile.photo.update'"
                (buttonClick)="triggerUpdate()"
                icon="ui/action/symbols/download"
                iconWidth="20"
            >
                <eb-label size="lg">{{ 'profile.photo.update' | transloco }}</eb-label>
            </eb-button-with-icon>

            <eb-button-with-icon
                class="modal-profile-photo__delete"
                [disabled]="!hasPhoto()"
                [label]="'profile.photo.remove'"
                (buttonClick)="remove()"
                icon="ui/action/symbols/trash"
                iconWidth="20"
            >
                <eb-label size="lg">{{ 'profile.photo.remove' | transloco }}</eb-label>
            </eb-button-with-icon>
        </div>
    }
}
